import {DesignSystemExportFnOutput, DesignSystemStaticSizes} from '../../_interfaces/designSystem';

export default (prefix: string, datas: DesignSystemStaticSizes): DesignSystemExportFnOutput => {

  // Placeholders
  const placeholders: DesignSystemExportFnOutput = {};

  for (const [component, data] of Object.entries(datas)) {
    for (const [cssProperty, family] of Object.entries(data)) {

      const placeholderName = `${prefix}-${component}-${cssProperty}`;
      placeholders[`%${placeholderName}`] = {
        sassdoc: {
          '': `Extend design system [${placeholderName}]`,
          '@name': `${placeholderName}`,
        },
        responsive: {},
      };

      for (const [breakpoint, value] of Object.entries(family)) {

        placeholders[`%${placeholderName}`].responsive[breakpoint] = {};
        placeholders[`%${placeholderName}`].responsive[breakpoint][cssProperty] = `${value}px`;
      }
    }
  }

  return placeholders;
};
